import {
  Component,
  DestroyRef,
  Input,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Observable, ReplaySubject, switchMap, tap } from 'rxjs';

import { AppState } from 'src/app/reducers';
import { Post } from 'src/app/core/models/core.models';
import { Store } from '@ngrx/store';
import { selectPostById, selectPostLoading } from 'src/app/core/reducers';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

/**
 * Post details pane tab rendering the post's screen capture.
 *
 * `post_screen_capture` is an absolute URL served by the backend, so it is
 * bound directly as the image source — no domain prefixing.
 */
@Component({
  selector: 'app-post-screen-capture',
  templateUrl: './post-screen-capture.component.html',
  styleUrls: ['./post-screen-capture.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PostScreenCaptureComponent implements OnInit {
  @Input() set postId(id: string) {
    this.postId$.next(id);
  }

  post$: Observable<Post>;
  postLoading$: Observable<boolean>;
  screenCaptureUrl: string | null = null;

  private postId$ = new ReplaySubject<string>(1);
  private destroyRef = inject(DestroyRef);

  constructor(private store: Store<AppState>) {}

  ngOnInit(): void {
    this.postId$
      .pipe(
        tap((id) => {
          this.post$ = this.store.select(selectPostById(id));
          this.postLoading$ = this.store.select(selectPostLoading(id));
        }),
        switchMap((id) => this.store.select(selectPostById(id))),
        tap((post) => {
          this.screenCaptureUrl = post?.post_screen_capture || null;
        }),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe();
  }
}
